export default "__VITE_ASSET__z94NjmPu__"